import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Search,
  MoreHorizontal,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  LinkIcon,
  X,
  Copy,
} from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";
import SortableHeader from "../../components/SortableHeader";
import noBrandImage from '../../assets/img/brand/no-brand-img.png';
import noStockInstanceImage from '../../assets/img/emptyStockInstance.png';
import PlatformOrderDrawer from "../../components/PlatformOrderDrawer";
import { multiWordSearch } from "../../utils/multiWordSearch";
import emptySearchImg from "../../assets/img/brand/empty-search.png";
import FilterDrawer from "../../components/FilterDrawer";

// Enhanced dummy data for Shopee platform
const shopeeData = [
  {
    id: "2508040JSM0PRY",
    status: "To Ship",
    itemsCount: 5,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,433.27",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung Galaxy Z Fold 7 Snapdragon 8 Elite",
        variation: "Z Fold 7 12GB 512GB, Blue Shadow",
        unitPrice: "SGD 1,498.00",
        qty: 1
      },
      {
        name: "Mister Mobile Mercury Goospery Phone Case",
        variation: "Clear",
        unitPrice: "SGD 1,498.00",
        qty: 1
      },
      {
        name: "Mister Mobile Tempered Glass/Screen Protector",
        variation: "Screen Protector, Samsung (All Models)",
        unitPrice: "SGD 1,498.00",
        qty: 1
      },
      {
        name: "Mister Mobile Mascot Cable Protector",
        variation: "Clear",
        unitPrice: "SGD 0",
        qty: 1
      },
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung Galaxy Z Fold 7",
        stockSku: "12GB 512GB, Blue Shadow",
        branch: "Bedok",
        price: "1498",
        skuId: "35334107 123456 2",
        badge: "New",
        status: "Unactivated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  },
  {
    id: "2508040JSM0PRY-2",
    status: "To Ship",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "0 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: []
  },
  {
    id: "2508040JSM0PRY-3",
    status: "To Ship",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Chinatown",
        price: "700",
        skuId: "9585968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  },
  {
    id: "2508040JSM0PRY-4",
    status: "Shipping",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "SGD 1,200.50",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Bedok",
        price: "500",
        skuId: "25685968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  },
  {
    id: "2508040JSM0PRY-5",
    status: "Completed",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "SGD 1,200.50",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Bedok",
        price: "500",
        skuId: "1115968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  }
];

// Enhanced dummy data for Lazada platform
const lazadaData = [
  {
    id: "251219QW47TGCS",
    status: "To Ship",
    itemsCount: 2,
    orderTime: "2025-12-19 09:10",
    updateTime: "2025-12-20 09:10",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "0 Linked",
    totalPrice: "SGD 1,112,000.00",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung Galaxy Z Fold 6 5G AI Smartphone (12GB RAM, 1TB) - Blue",
        variation: "12GB RAM, 1TB, Blue",
        unitPrice: "SGD 898.00",
        qty: 1
      },
      {
        name: "Samsung 25W Super Fast Charging Wall Charger",
        variation: "White, UK Plug",
        unitPrice: "SGD 28.00",
        qty: 1
      }
    ],
    stockInstances: [

    ]
  },
  {
    id: "251219QSVSWF3Y",
    status: "Shipping",
    itemsCount: 3,
    orderTime: "2025-12-19 07:07",
    updateTime: "2025-12-20 07:07",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,112.00",
    settlementPrice: "-",
    products: [
      {
        name: "Xiaomi Redmi Note 13 Pro+ 5G (12GB RAM, 512GB) - Midnight Black",
        variation: "12GB RAM, 512GB, Black",
        unitPrice: "SGD 499.00",
        qty: 2
      },
      {
        name: "Xiaomi 67W Turbo Charger",
        variation: "Black, Type-C",
        unitPrice: "SGD 39.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Xiaomi Redmi Note 13 Pro+",
        stockSku: "23090RA98I, Black, 12GB 512GB",
        badge: "New",
        branch:"Bedok",
        price:"4500",
        skuId:"12585968856",
        status: "Activated",
        instanceQty: 2,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      },
      {
        stockName: "Xiaomi 67W Charger",
        stockSku: "MDY-14-ES, Black",
        branch:"Chinatown",
        price:"500",
        skuId:"96685968856",
        badge: "New",
        status: "Unactivated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      }
    ]
  },
  {
    id: "251219QKNKM09D",
    status: "Completed",
    itemsCount: 1,
    orderTime: "2025-12-19 07:03",
    updateTime: "2025-12-20 07:03",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,000.00",
    settlementPrice: "SGD 1,000,000.00",
    products: [
      {
        name: "Apple iPhone 15 Pro Max (256GB) - Natural Titanium",
        variation: "256GB, Natural Titanium",
        unitPrice: "SGD 1,899.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Apple iPhone 15 Pro Max",
        stockSku: "A3106, Natural Titanium, 256GB",
        branch:"Bedok",
        price:"500",
        skuId:"25685968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      }
    ]
  },
  {
    id: "251219MWY2MCDW",
    status: "Cancelled",
    itemsCount: 4,
    orderTime: "2025-12-19 07:01",
    updateTime: "2025-12-20 07:01",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,100.00",
    settlementPrice: "SGD 1,000,000.00",
    products: [
      {
        name: "Google Pixel 8 Pro (12GB RAM, 512GB) - Obsidian",
        variation: "12GB RAM, 512GB, Obsidian",
        unitPrice: "SGD 1,299.00",
        qty: 1
      },
      {
        name: "Google Pixel Buds Pro",
        variation: "Charcoal",
        unitPrice: "SGD 199.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Google Pixel 8 Pro",
        stockSku: "GC3VE, Obsidian, 12GB 512GB",
        branch:"Bedok",
        price:"500",
        skuId:"2555968856",
        badge: "Old",
        status: "Activated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      },
      {
        stockName: "Google Pixel Buds Pro",
        stockSku: "GA3TZ, Charcoal",
        branch:"Bedok",
        price:"900",
        skuId:"9985968856",
        badge: "New",
        status: "Unactivated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      }
    ]
  },
  {
    id: "251219QDM7QT4",
    status: "To Ship",
    itemsCount: 2,
    orderTime: "2025-12-19 22:30",
    updateTime: "2025-12-19 22:30",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,112,000.00",
    settlementPrice: "SGD 1,000,000.00",
    products: [
      {
        name: "OnePlus 12 (16GB RAM, 512GB) - Flowy Emerald",
        variation: "16GB RAM, 512GB, Flowy Emerald",
        unitPrice: "SGD 999.00",
        qty: 1
      },
      {
        name: "OnePlus 100W SuperVOOC Charger",
        variation: "White, Type-C",
        unitPrice: "SGD 49.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "OnePlus 12",
        stockSku: "CPH2581, Flowy Emerald, 16GB 512GB",
        branch:"Bedok",
        price:"800",
        skuId:"1115968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      },
      {
        stockName: "OnePlus 100W Charger",
        stockSku: "VCKBHB, White",
        branch:"Bedok",
        price:"3500",
        skuId:"11185968856",
        badge: "New",
        status: "Unactivated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      }
    ]
  },
  {
    id: "251219PVG9UJQE",
    status: "To Ship",
    itemsCount: 1,
    orderTime: "2025-12-19 22:26",
    updateTime: "2025-12-19 22:26",
    lastModifiedTime: "2025-12-20 09:10",
    lastModifiedBy : "Test Test",
    openId : "8d5815b4-38d2-405c-86c0-3366fa7cbccc",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,112,000.00",
    settlementPrice: "SGD 1,000,000.00",
    products: [
      {
        name: "Sony WH-1000XM5 Wireless Noise Cancelling Headphones",
        variation: "Silver",
        unitPrice: "SGD 499.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Sony WH-1000XM5",
        stockSku: "WH1000XM5, Silver",
        branch:"Bedok",
        price:"500",
        skuId:"1174185968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        instancesName : "123456-78-901234-5",
        instancesLocation : "Chinatown",
        InstancesPrice : "SGD 5,000.00"
      }
    ]
  },
];

// Enhanced dummy data for TikTok platform
const tiktokData = [
  {
    id: "2508040JSM0PRY-TK1",
    status: "To Ship",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "0 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: []
  },
  {
    id: "2508040JSM0PRY-TK2",
    status: "To Ship",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "-",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Chinatown",
        price: "700",
        skuId: "9585968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  },
  {
    id: "2508040JSM0PRY-TK3",
    status: "Shipping",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "SGD 1,200.50",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Bedok",
        price: "500",
        skuId: "25685968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  },
  {
    id: "2508040JSM0PRY-TK4",
    status: "Completed",
    itemsCount: 1,
    orderTime: "2025-01-23 12:30",
    updateTime: "2025-01-23 12:30",
    linkedStock: "2 Linked",
    totalPrice: "SGD 1,399.00",
    settlementPrice: "SGD 1,200.50",
    products: [
      {
        name: "Samsung 25W USB-C Power Adapter Singapore",
        variation: "Adapter (Black), Original",
        unitPrice: "SGD 16.00",
        qty: 1
      }
    ],
    stockInstances: [
      {
        stockName: "Samsung 25W USB-C Power Adapter",
        stockSku: "Adapter (Black), Original",
        branch: "Bedok",
        price: "500",
        skuId: "1115968856",
        badge: "New",
        status: "Activated",
        instanceQty: 1,
        image: "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
      }
    ]
  }
];

const platformConfig = {
  '/platform-order-shopee': {
    label: 'Shopee SG',
    data: shopeeData,
    fulfillStatuses: ['To Ship', 'Shipping']
  },
  '/platform-order-lazada': {
    label: 'Lazada SG',
    data: lazadaData,
    fulfillStatuses: ['To Ship', 'Shipping']
  },
  '/platform-order-tiktok': {
    label: 'TikTok SG',
    data: tiktokData,
    fulfillStatuses: ['To Ship']
  }
};

const PAGE_SIZE = 10;

export default function PlatformOrderPage() {
  const { pathname } = useLocation();
  const config = platformConfig[pathname] || platformConfig['/platform-order-shopee'];
  const platformData = config.data;

  const [activeTab, setActiveTab] = useState("platform-order");
  const [orderTab, setOrderTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedIds, setSelectedIds] = useState([]);
  const [actionDropdownOpenId, setActionDropdownOpenId] = useState(null);
  const [productDropdownOpenId, setProductDropdownOpenId] = useState(null);
  const [stockDropdownOpenId, setStockDropdownOpenId] = useState(null);
  const [tooltipContent, setTooltipContent] = useState("");
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [copied, setCopied] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerTab, setDrawerTab] = useState('entity-info');

  const actionDropdownRef = useRef(null);
  const productDropdownRef = useRef(null);
  const stockDropdownRef = useRef(null);
  const actionButtonRefs = useRef({});
  const productButtonRefs = useRef({});
  const stockButtonRefs = useRef({});
  const drawerContainerRef = useRef(null);
  const history = useHistory();

  const breadcrumbs = ["Order - Platform", config.label];
  const [tempValues, setTempValues] = useState({
    order_status: [],
    // order_items: [],
    order_items_min: '',
    order_items_max: '',
    order_time: '',
    update_time: '',
    total_price_min: '',
    total_price_max: '',
    settlement_price_min: '',
    settlement_price_max: '',
  });

  const filterSections = [
    {
      label: "Order Status",
      type: "list",
      key: "order_status",
      data: ["To Ship", "Shipping", "Completed", "Cancelled"],
      showDropdownIcon: true,
      renderItem: (name) => ({
        id: name, // unique identifier (string works fine)
        title: name, // displayed text
        subtitle: "", // optional
        image: null, // optional
      }),
    },
    {
      label: "Order Items",
      type: "rangeNormal",
      key: "order_items"
    },
    {
      label: "Order Time",
      key: "order_time",
      type: "dateRangeWithTime", // or "date" — depends on your drawer input types
    },
    {
      label: "Update Time",
      key: "update_time",
      type: "dateRangeWithTime", // or "date" — depends on your drawer input types
    },
    {
      label: "Total Price",
      type: "range",
      key: "total_price",
      changeColor:true
    },
    {
      label: "Settlement Price",
      type: "range",
      key: "settlement_price",
      changeColor:true
    },
  ];

  const isInitialTableEmpty = platformData?.length === 0;


  const FilterActiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333"
        stroke="#0D6EFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_4516_4830)">
        <path
          d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z"
          fill="#0D6EFD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4516_4830">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(11 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const FilterInactiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const thStyle = {
    textAlign: "left",
    padding: "10px 12px",
    fontSize: 12,
    fontWeight: 600,
  };

  const tdStyle = {
    padding: "12px",
    borderTop: "1px solid #E9ECEF",
    verticalAlign: "top",
    fontSize: 12,
  };

  const badgeYellow = {
    fontSize: 10,
    padding: "3px 8px",
    background: "#FFD600",
    borderRadius: 99,
    fontWeight: 600,
  };


  const Field = ({ label, value }) => (
  <div>
    {/* Label */}
    <div
      style={{
        fontFamily: "Montserrat",
        fontSize: 12,
        fontWeight: 700,
        color: "#212529",
        marginBottom: 6,
      }}
    >
      {label}
    </div>

    {/* Value */}
    <div
      style={{
        fontFamily: "Montserrat",
        fontSize: 12,
        fontWeight: 400,
        color: "#212529",
      }}
    >
      {value || "-"}
    </div>
  </div>
);


  const copyToClipboard = (text) => {
    if (!text) return;

    navigator.clipboard.writeText(text);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const getDrawerListings = () => {
      console.log(selectedRow);
        if (!selectedRow || !Array.isArray(selectedRow.listings)) return [];
        return selectedRow.listings;
    };

    const DRAWER_PAGE_SIZE = 5;
    const [orderItemsPage, setOrderItemsPage] = useState(1);
    const [stockItemsPage, setStockItemsPage] = useState(1);

    // const [drawerCurrentPage, setDrawerCurrentPage] = useState(1);

    // // reset drawer page when selectedRow changes
    // useEffect(() => {
    //     setDrawerCurrentPage(1);
    // }, [selectedRow]);
    // const drawerListings = getDrawerListings();
    // const drawerTotal = drawerListings.length;
    // const drawerTotalPages = Math.max(1, Math.ceil(drawerTotal / DRAWER_PAGE_SIZE));
    // const drawerPageData = drawerListings.slice(
    //     (drawerCurrentPage - 1) * DRAWER_PAGE_SIZE,
    //     drawerCurrentPage * DRAWER_PAGE_SIZE
    // );

    // ORDER ITEMS PAGINATION
const orderItems = selectedRow?.products || [];
const orderItemsTotal = orderItems.length;
const orderItemsTotalPages = Math.ceil(orderItemsTotal / DRAWER_PAGE_SIZE);

const paginatedOrderItems = orderItems.slice(
  (orderItemsPage - 1) * DRAWER_PAGE_SIZE,
  orderItemsPage * DRAWER_PAGE_SIZE
);

// // STOCK ITEMS PAGINATION
// const stockItems = selectedRow?.stockInstances || [];
// const stockItemsTotal = stockItems.length;
// const stockItemsTotalPages = Math.ceil(stockItemsTotal / DRAWER_PAGE_SIZE);

// const paginatedStockItems = stockItems.slice(
//   (stockItemsPage - 1) * DRAWER_PAGE_SIZE,
//   stockItemsPage * DRAWER_PAGE_SIZE
// );

  const onRowClick = (row) => {
        setSelectedRow(row);
        setDrawerTab('entity-info');
        setDrawerOpen(true);
    };

  // Filter data based on selected tab
  const filteredData = useMemo(() => {
    let data = [...platformData];

    // Filter by tab
    if (orderTab === "to-link") {
      data = data.filter(item => item.linkedStock === "0 Linked");
    } else if (orderTab === "to-fulfill") {
      data = data.filter(item => config.fulfillStatuses.includes(item.status));
    }

    // Filter by search
    if (searchTerm) {
      // const words = searchTerm.toLowerCase().trim().split(/\s+/);

      data = multiWordSearch(data, searchTerm, (item) => [
        item.id,
        item.status,
        item.linkedStock,
        String(item.totalPrice),
        String(item.settlementPrice),
        ...(item.products?.flatMap(product => [
          product.name,
          product.variation,
          String(product.unitPrice)
        ]) || [])
      ]);
      /*
      data = data.filter(item => {
        // Collect all searchable text from item
        const searchableValues = [
          item.id,
          item.status,
          item.linkedStock,
          String(item.totalPrice),
          String(item.settlementPrice),
          ...(item.products?.flatMap(product => [
            product.name,
            product.variation,
            String(product.unitPrice)
          ]) || [])
        ]
          .filter(Boolean)
          .map(val => val.toLowerCase());

        // Every word must match somewhere
        return words.every(word =>
          searchableValues.some(value =>
            value.includes(word)
          )
        );
      });*/
      /*
      const term = searchTerm.toLowerCase();
      data = data.filter(item =>
        item.id.toLowerCase().includes(term) ||
        item.status.toLowerCase().includes(term) ||
        item.linkedStock.toLowerCase().includes(term) ||

        String(item.totalPrice)?.toLowerCase().includes(term) ||
        String(item.settlementPrice)?.toLowerCase().includes(term) ||
        item.products?.some(product =>
            product.name?.toLowerCase().includes(term) ||
            product.variation?.toLowerCase().includes(term) ||
            product.unitPrice?.toLowerCase().includes(term)
        )

      );
      */
    }

    // apply filters
    if (appliedFilter) {
      if(appliedFilter['order_status'].length > 0) {
        const lowerOrderStatus = appliedFilter['order_status'].map(t => t.toLowerCase());
        data = data.filter(item =>
          lowerOrderStatus.includes(item.status.toLowerCase())
        );
      }
      if(appliedFilter['order_items_min']) {
        data = data.filter(item =>
          parseInt(appliedFilter['order_items_min']) <= parseInt(item.itemsCount)
        );
      }
      if(appliedFilter['order_items_max']) {
        data = data.filter(item =>
          parseInt(appliedFilter['order_items_max']) >= parseInt(item.itemsCount)
        );
      }
      if(appliedFilter['total_price_min']) {
        data = data.filter(item =>
          parseInt(appliedFilter['total_price_min']) <= Number(item.totalPrice.replace(/[^\d.-]/g, ""))
        );
      }
      if(appliedFilter['total_price_max']) {
        data = data.filter(item =>
          parseInt(appliedFilter['total_price_max']) >= Number(item.totalPrice.replace(/[^\d.-]/g, ""))
        );
      }
      if(appliedFilter['settlement_price_min']) {
        data = data.filter(item =>
          parseInt(appliedFilter['settlement_price_min']) <= Number(item.settlementPrice.replace(/[^\d.-]/g, ""))
        );
      }
      if(appliedFilter['settlement_price_max']) {
        data = data.filter(item =>
          parseInt(appliedFilter['settlement_price_max']) >= Number(item.settlementPrice.replace(/[^\d.-]/g, ""))
        );
      }
      if (appliedFilter?.order_time_start || appliedFilter?.order_time_end) {
        const start = appliedFilter.order_time_start ?? null;
        const end = appliedFilter.order_time_end ?? null;
        data = data.filter((item) => {
          const rowTime = new Date(item.orderTime).getTime();
          if (start && rowTime < start) return false;
          if (end && rowTime > end) return false;
          return true;
        });
      }
      if (appliedFilter?.update_time_start || appliedFilter?.update_time_end) {
        const start = appliedFilter.update_time_start ?? null;
        const end = appliedFilter.update_time_end ?? null;
        data = data.filter((item) => {
          const rowTime = new Date(item.updateTime).getTime();
          if (start && rowTime < start) return false;
          if (end && rowTime > end) return false;
          return true;
        });
      }
    }


    // Apply sorting
    if (sortField) {
      data.sort((a, b) => {
        let aVal = a[sortField];
        let bVal = b[sortField];

        if (sortField === "orderTime" || sortField === "updateTime") {
          aVal = new Date(aVal).getTime();
          bVal = new Date(bVal).getTime();
        }

        if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    }

    return data;
  }, [orderTab, searchTerm, sortField, sortOrder, appliedFilter, platformData]);

  const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
  const pageData = filteredData.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds(ids =>
      ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
    );
  };

  const toggleAll = () => {
    if (selectedIds.length === pageData.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(pageData.map(d => d.id));
    }
  };

  const toggleActionDropdown = (id, event) => {
    event.stopPropagation();
    if (actionDropdownOpenId === id) {
      setActionDropdownOpenId(null);
    } else {
      const btn = actionButtonRefs.current[id];
      if (btn) {
        const rect = btn.getBoundingClientRect();
        setActionDropdownPosition({
          top: rect.bottom + window.scrollY + 4,
          left: rect.left + window.scrollX,
        });
      }
      setActionDropdownOpenId(id);
      // Close other dropdowns
      setProductDropdownOpenId(null);
      setStockDropdownOpenId(null);
    }
  };

  const toggleProductDropdown = (id, event) => {
    event.stopPropagation();
    if (productDropdownOpenId === id) {
      setProductDropdownOpenId(null);
    } else {
      const btn = productButtonRefs.current[id];
      if (btn) {
        const row = btn.closest('tr');
        const rect = row.getBoundingClientRect();
        setProductDropdownPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        });
      }
      setProductDropdownOpenId(id);
      // Close other dropdowns
      setActionDropdownOpenId(null);
      setStockDropdownOpenId(null);
    }
  };

  const toggleStockDropdown = (id, event) => {
    event.stopPropagation();
    if (stockDropdownOpenId === id) {
      setStockDropdownOpenId(null);
    } else {
      const btn = stockButtonRefs.current[id];
      if (btn) {
        const row = btn.closest('tr');
        const rect = row.getBoundingClientRect();
        setStockDropdownPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        });
      }
      setStockDropdownOpenId(id);
      // Close other dropdowns
      setActionDropdownOpenId(null);
      setProductDropdownOpenId(null);
    }
  };

  const [actionDropdownPosition, setActionDropdownPosition] = useState({ top: 0, left: 0 });
  const [productDropdownPosition, setProductDropdownPosition] = useState({ top: 0, left: 0 });
  const [stockDropdownPosition, setStockDropdownPosition] = useState({ top: 0, left: 0 });

  const showTooltipHandler = (text, event) => {
    const rect = event.target.getBoundingClientRect();
    setTooltipContent(text);
    setTooltipPosition({
      top: rect.top + window.scrollY - 33 - (text.length > 46 ? 20 : 0),
      left: rect.left + window.scrollX,
    });
    setShowTooltip(true);
  };

  const hideTooltipHandler = () => {
    setShowTooltip(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // Action dropdown
      if (
        actionDropdownRef.current &&
        !actionDropdownRef.current.contains(event.target) &&
        !Object.values(actionButtonRefs.current).some(btn => btn?.contains(event.target))
      ) {
        setActionDropdownOpenId(null);
      }

      // Product dropdown
      if (
        productDropdownRef.current &&
        !productDropdownRef.current.contains(event.target) &&
        !Object.values(productButtonRefs.current).some(btn => btn?.contains(event.target))
      ) {
        setProductDropdownOpenId(null);
      }

      // Stock dropdown
      if (
        stockDropdownRef.current &&
        !stockDropdownRef.current.contains(event.target) &&
        !Object.values(stockButtonRefs.current).some(btn => btn?.contains(event.target))
      ) {
        setStockDropdownOpenId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getStatusBadgeClass = (status) => {
    switch(status.toLowerCase()) {
      case "to ship":
        return "status-badge to-ship";
      case "shipping":
        return "status-badge shipping";
      case "completed":
        return "status-badge completed";
      case "cancelled":
        return "status-badge cancelled";
      default:
        return "status-badge";
    }
  };

  const truncateText = (text, maxLength = 50) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <div className="company-body new-look stock-wrap">
      {/* Breadcrumbs */}
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <span key={index} className="breadcrumb-item">
            {crumb}
            {index !== breadcrumbs.length - 1}
          </span>
        ))}
      </div>

      <div className="employee-tabs-container">
        {/* Tab Buttons */}
        <div className="tabs">
          <button
            className={`tab ${activeTab === "platform-order" ? "active" : ""}`}
            onClick={() => setActiveTab("platform-order")}
            style={{
              padding: 10,
              fontSize: 12,
              fontWeight: 600,
              minWidth: 88,
              gap: 10,
            }}
          >
            Orders
          </button>
        </div>

        {/* Tab Contents */}
        {activeTab === "platform-order" && (
          <div>
            {/* Sub-tabs: All, To Link, To Fulfill */}
            <div
              style={{
                display: "flex",
                gap: "12px",
                borderRadius: "12px",
                width: "fit-content",
                marginBottom: "20px",
              }}
            >
              {["all", "to-link", "to-fulfill"].map((tab) => {
                const isActive = orderTab === tab;

                return (
                  <button
                    key={tab}
                    onClick={() => {
                      setOrderTab(tab);
                      setCurrentPage(1);
                      setSelectedIds([]);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "200px",
                      height: "45px",
                      minWidth: "100px",
                      maxWidth: "200px",
                      minHeight: "9.89px",
                      padding: "10px",
                      gap: "5px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      border: "none",
                      fontSize: 12,
                      ...(isActive
                        ? {
                            borderTop: "3px solid #FFEB00",
                            background: "#FFF",
                            boxShadow: "0 1px 4px 0 rgba(0,0,0,0.10)",
                            fontWeight: "600",
                            color: "#212529",
                          }
                        : {
                            borderTop: "3px solid transparent",
                            background: "#F8F9FA",
                            boxShadow: "0 1px 4px 0 rgba(0,0,0,0.10)",
                            fontWeight: "500",
                            color: "#6C757D",
                          }),
                    }}
                  >
                    {tab === "all"
                      ? "All"
                      : tab === "to-link"
                      ? "To Link"
                      : "To Fulfill"}
                    {tab === "to-link" && (
                      <span style={{ display:"flex",justifyContent:"center",fontSize:"8px",marginLeft: "4px",height:"20px",width:"20px",
padding: "2px 5px", color: "#212529",borderRadius: "99px",background:"#FFEB00",alignItems:"center",fontWeight:600}}>
                        {platformData.filter(d => d.linkedStock === "0 Linked").length}
                      </span>
                    )}
                    {tab === "to-fulfill" && (
                      <span style={{ display:"flex",justifyContent:"center",fontSize:"8px",marginLeft: "4px",height:"20px",width:"20px",
padding: "2px 5px", color: "#212529",borderRadius: "99px",background:"#FFEB00",alignItems:"center",fontWeight:600}}>
                        {platformData.filter(d => d.status === "To Ship").length}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="tab-content" style={{background:"white", padding:"20px", borderRadius:"8px"}}>
              {/* Search */}
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
                <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                  <div className="search-box" style={{ width: "300px",position: 'relative' }}>
                    <Search size={20} />
                    <input
                      type="text"
                      placeholder="Search orders..."
                      disabled={isInitialTableEmpty}
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
				  { searchTerm && (
                      <button
                        onClick={ () => setSearchTerm('') }
                        style={{
                          position: 'absolute',
                          right: '4px',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '4px',
                        }}
                      >
                        <X size={16} />
                      </button>
                    )}
                  </div>
                  <button
                    className={`icon-btn p-2 filter-btn ${
                      appliedFilter ? "applied" : ""
                    }`}
                    onClick={() =>
                      !isInitialTableEmpty &&
                      setFilterPopupOpen((prev) => !prev)
                    }
                    disabled={isInitialTableEmpty}
                    style={{
                      border: appliedFilter
                        ? "1px solid #2C7BE5"
                        : "1px solid #6C757D",

                      borderWidth: "1px",
                      color: appliedFilter ? "#2C7BE5" : "#6C757D",

                      background: isInitialTableEmpty
                        ? "#E9ECEF"
                        : appliedFilter
                          ? "#CFE2FF"
                          : "#FFFFFF",

                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      opacity: isInitialTableEmpty ? 0.6 : 1,
                      pointerEvents: isInitialTableEmpty
                        ? "none"
                        : "auto",
                      cursor: isInitialTableEmpty
                        ? "not-allowed"
                        : "pointer",
                      borderRadius: "8px",
                    }}
                  >
                    {appliedFilter && !isInitialTableEmpty ? (
                      <FilterActiveIcon />
                    ) : (
                      <FilterInactiveIcon />
                    )}
                  </button>
                  <FilterDrawer
                    isOpen={filterPopupOpen}
                    onClose={() => {
                      setTempValues({
                        order_status: [],
                        // order_items: [],
                        order_time_start: '',
                        order_time_end: '',
                        update_time_start: '',
                        update_time_end: '',
                        order_items_min: '',
                        order_items_max: '',
                        order_time: '',
                        update_time: '',
                        total_price_min: '',
                        total_price_max: '',
                        settlement_price_min: '',
                        settlement_price_max: '',
                      });
                      setFilterPopupOpen(false);
                      setAppliedFilter(null);
                    }}
                    sections={filterSections}
                    tempValues={tempValues}
                    setTempValues={setTempValues}
                    onApply={() => {
                      console.log(tempValues);
                      const hasAnyFilter =
                        tempValues.order_status?.length ||
                        tempValues.order_time_start ||
                        tempValues.order_time_end ||
                        tempValues.update_time_start ||
                        tempValues.update_time_end ||
                        tempValues.order_items_min ||
                        tempValues.order_items_max ||
                        tempValues.settlement_price_min ||
                        tempValues.settlement_price_max ||
                        tempValues.total_price_min  ||
                        tempValues.total_price_max

                      if (!hasAnyFilter) {
                        setAppliedFilter(null);
                        setFilterPopupOpen(false);
                        return;
                      }
                      setAppliedFilter({
                        order_status: tempValues.order_status || [],
                        order_time_start: tempValues.order_time_start || "",
                        order_time_end: tempValues.order_time_end || "",
                        update_time_start: tempValues.update_time_start || "",
                        update_time_end: tempValues.update_time_end || "",
                        order_items_min: tempValues.order_items_min || "",
                        order_items_max: tempValues.order_items_max || "",
                        total_price_min: tempValues.total_price_min || "",
                        total_price_max: tempValues.total_price_max || "",
                        settlement_price_min: tempValues.settlement_price_min || "",
                        settlement_price_max: tempValues.settlement_price_max || "",
                      });
                      setFilterPopupOpen(false);
                    }}
                    onClear={() => {
                      const empty = {
                        order_status: [],
                        // order_items: [],
                        order_time_start: '',
                        order_time_end: '',
                        update_time_start: '',
                        update_time_end: '',
                        order_items_min: '',
                        order_items_max: '',
                        order_time: '',
                        update_time: '',
                        total_price_min: '',
                        total_price_max: '',
                        settlement_price_min: '',
                        settlement_price_max: '',
                      };

                      setTempValues(empty);
                      setAppliedFilter(null);
                    }}
                  />
                </div>
              </div>

              {/* Table */}
              <div className="table-wrapper" style={{ overflowX: "auto", border: "none", position: "relative" }}>
                {pageData.length > 0 && (
                  <table className="entities-table" style={{ width: "100%", tableLayout: "auto", minWidth: "900px" }}>
                    <thead>
                      <tr>
                        <th className="sticky-first-col" style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px", position: "sticky", left: 0, zIndex: 3, boxShadow: "4px 0 6px -4px rgba(0,0,0,0.18)" }}>
                          <SortableHeader
                            label="Order"
                            field="id"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px" }}>
                          <SortableHeader
                            label="Order Time"
                            field="orderTime"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px" }}>
                          <SortableHeader
                            label="Update Time"
                            field="updateTime"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px" }}>
                          <SortableHeader
                            label="Linked StockInstance"
                            field="linkedStock"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px" }}>
                          <SortableHeader
                            label="Total Price"
                            field="totalPrice"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th style={{ backgroundColor: "#E9ECEF", padding: "10px", height:"45px" }}>
                          <SortableHeader
                            label="Settlement Price"
                            field="settlementPrice"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                          />
                        </th>
                        <th className="sticky-last-col" style={{ textAlign: "center", backgroundColor: "#E9ECEF", padding: "10px", height:"45px", position: "sticky", right: 0, zIndex: 3, boxShadow: "-4px 0 6px -4px rgba(0,0,0,0.18)" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pageData.map((row, idx) => (
                        <React.Fragment key={row.id}>
                          <tr
                            className={[
                              idx % 2 ? "striped" : "",
                              selectedIds.includes(row.id) ? "row-selected" : "",
                            ].join(" ")}
                            onClick={() => onRowClick(row)}
                          >
                            <td className="sticky-first-col">
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                  <span style={{ fontWeight: 500,marginBottom:"6px" }}>{row.id}</span>
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    <span className={getStatusBadgeClass(row.status)}>
                                      {row.status}
                                    </span>
                                    <span style={{ fontSize: "11px", color: "#6C757D" }}>
                                      {row.itemsCount} Items
                                    </span>
                                  </div>
                                </div>
                                <button
                                  ref={(el) => (productButtonRefs.current[row.id] = el)}
                                  onClick={(e) => toggleProductDropdown(row.id, e)}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ChevronDown
                                    size={16}
                                    style={{
                                      transform: productDropdownOpenId === row.id ? "rotate(180deg)" : "none",
                                      transition: "transform 0.2s",
                                      color: "#6C757D"
                                    }}
                                  />
                                </button>
                              </div>
                            </td>
                            <td>{row.orderTime}</td>
                            <td>{row.updateTime}</td>
                            <td style={{ color: row.linkedStock === "0 Linked" ? "#58151C" : "inherit" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {row.linkedStock}
                                <button
                                  ref={(el) => (stockButtonRefs.current[row.id] = el)}
                                  onClick={(e) => toggleStockDropdown(row.id, e)}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "4px",
                                    marginLeft: "8px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <ChevronDown
                                    size={16}
                                    style={{
                                      transform: stockDropdownOpenId === row.id ? "rotate(180deg)" : "none",
                                      transition: "transform 0.2s",
                                      color: "#6C757D"
                                    }}
                                  />
                                </button>
                              </div>
                            </td>
                            <td>{row.totalPrice}</td>
                            <td>{row.settlementPrice}</td>
                            <td className="sticky-last-col" style={{ textAlign: "center" }}>
                              <button
                                ref={(el) => (actionButtonRefs.current[row.id] = el)}
                                className="action-btn"
                                onClick={(e) => toggleActionDropdown(row.id, e)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  padding: "8px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "4px",
                                }}
                              >
                                <MoreHorizontal size={20} color="#6C757D" />
                              </button>
                            </td>
                          </tr>

                          {/* Product Details Dropdown */}
                          {productDropdownOpenId === row.id && (
                            <tr>
                              <td colSpan="7" style={{ padding: 0, borderBottom: "none" }}>
                                <div
                                  ref={productDropdownRef}
                                  className="product-dropdown"
                                  style={{
                                    position: "fixed",
                                    top: productDropdownPosition.top,
                                    left: productDropdownPosition.left,
                                    background: "white",
                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                                    zIndex: 1000,
                                    width: "600px",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                      <tr style={{ backgroundColor: "#FFEB00" }}>
                                        <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Product</th>
                                        <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Unit Price</th>
                                        <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Qty</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {row.products.map((product, index) => (
                                        <tr key={index} style={{ borderBottom: index < row.products.length - 1 ? "1px solid #E9ECEF" : "none" }}>
                                          <td style={{ padding: "12px 16px" }}>
                                            <div style={{ fontSize: "12px", fontWeight: "500" }}>
                                              <span
                                                onMouseEnter={(e) => showTooltipHandler(product.name, e)}
                                                onMouseLeave={hideTooltipHandler}
                                                style={{ cursor: "default" }}
                                              >
                                                {truncateText(product.name, 40)}
                                              </span>
                                            </div>
                                            <div
                                            onMouseEnter={(e) => showTooltipHandler('Variation: '+product.variation, e)}
                                            onMouseLeave={hideTooltipHandler}
                                           style={{ fontSize: "11px", color: "#6C757D", marginTop: "2px", cursor: "default" }}>
                                              Variation: {truncateText(product.variation, 30)}
                                            </div>
                                          </td>
                                          <td style={{ padding: "12px 16px", fontSize: "12px" }}>{product.unitPrice}</td>
                                          <td style={{ padding: "12px 16px", fontSize: "12px" }}>{product.qty}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}

                          {/* Stock Instance Dropdown */}
                          {stockDropdownOpenId === row.id && (
                            <tr>
                              <td colSpan="7" style={{ padding: 0, borderBottom: "none" }}>
                                <div
                                  ref={stockDropdownRef}
                                  className="stock-dropdown"
                                  style={{
                                    position: "fixed",
                                    top: stockDropdownPosition.top,
                                    left: '50%', // stockDropdownPosition.left,
                                    background: "white",
                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                                    zIndex: 1000,
                                    width: "449px",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  {row.stockInstances && row.stockInstances.length > 0 ? (
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                      <thead>
                                        <tr style={{ backgroundColor: "#FFEB00" }}>
                                          <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Stock</th>
                                          <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Stock Instance</th>
                                          <th style={{ padding: "12px 16px", textAlign: "left", fontSize: "12px", fontWeight: "700" }}>Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {row.stockInstances.map((stock, index) => (
                                          <tr key={index} style={{ borderBottom: index < row.stockInstances.length - 1 ? "1px solid #E9ECEF" : "1px solid #E9ECEF" }}>
                                            <td style={{ padding: "12px 16px" }}>
                                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <img
                                                  src={stock.image}
                                                  alt={stock.stockName}
                                                  style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    objectFit: "cover",
                                                    borderRadius: "4px"
                                                  }}
                                                />
                                                <div>
                                                  <div style={{ fontSize: "12px", fontWeight: "500" }}>
                                                    <span
                                                      onMouseEnter={(e) => showTooltipHandler(stock.stockName, e)}
                                                      onMouseLeave={hideTooltipHandler}
                                                      style={{ cursor: "default" }}
                                                    >
                                                      {truncateText(stock.stockName, 30)}
                                                    </span>
                                                  </div>
                                                  <div style={{ fontWeight:400, fontSize: "10px", color: "#6C757D" }}>
                                                    {stock.stockSku}
                                                  </div>
                                                  <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
                                                    <span style={{
                                                      padding: "2px 6px",
                                                      borderRadius: "12px",
                                                      fontSize: "10px",
                                                      fontWeight: "600",
                                                      backgroundColor: "#FFEB00",
                                                       color: "#212529",
                                                    }}>
                                                      {stock.badge}
                                                    </span>
                                                    <span style={{
                                                      padding: "2px 6px",
                                                      borderRadius: "12px",
                                                      fontSize: "10px",
                                                      fontWeight: "600",
                                                      backgroundColor: "#FFEB00",
                                                      color: "#212529"
                                                    }}>
                                                      {stock.status}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td style={{ padding: "12px 16px", fontSize: "11px", color: "#6C757D" }}>
                                              <div>
                                                  <div style={{ fontSize: "12px", fontWeight: "500" }}>
                                                    <span>
                                                      {stock.skuId}
                                                    </span>
                                                  </div>
                                                  <div style={{ fontWeight:400, fontSize: "10px", color: "#6C757D" }}>
                                                    {stock.branch} | SGD: {stock.price}
                                                  </div>
                                                </div>
                                            </td>
                                            <td style={{ padding: "12px 16px", fontSize: "12px" }}>{stock.instanceQty}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <div className="empty-state">
                                      <div className="empty-state-content">
                                        <div className="icon">
                                          <img
                                            src={noStockInstanceImage}
                                            alt="empty"
                                            style={{ width: 120, height: 120 }}
                                          />
                                        </div>
                                        <h1 className="no-item-title mt-2">No Linked StockInstances</h1>
                                        <p className="no-item-text">No StockInstances Linked to this Order.</p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                )}
                <div className="drawer-container" ref={drawerContainerRef}>
                    {/* Single-row Drawer (unchanged) */}
                  {drawerOpen && selectedRow && (
                    <PlatformOrderDrawer
                      drawerOpen={drawerOpen}
                      selectedRow={selectedRow}
                      setDrawerOpen={setDrawerOpen}
                      setSelectedRow = {setSelectedRow}
                      title="Lazada SG Order Info"
                    />
                  )}

                </div>

                {/* Action Dropdown Menu */}
                {actionDropdownOpenId && (
                  <div
                    ref={actionDropdownRef}
                    className="action-dropdown-menu"
                    style={{
                      position: "fixed",
                      top: actionDropdownPosition.top,
                      left: actionDropdownPosition.left,
                      background: "white",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                      zIndex: 1000,
                      minWidth: "160px",
                      borderRadius: "8px",
                      padding: "8px 0",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="dropdown-item">
                      <button onClick={() => {
                        const row = pageData.find(r => r.id === actionDropdownOpenId);
                        setActionDropdownOpenId(null);
                        if (row) {
                          onRowClick(row);
                        }
                      }}>
                        View Details
                      </button>
                    </div>
                    <div className="dropdown-item">
                      <button onClick={() => history.push("/platform-manage-order") }>
                        Manage
                      </button>
                    </div>
                  </div>
                )}

                {/* Tooltip */}
                {showTooltip && (
                  <div
                    style={{
                      position: "fixed",
                      top: tooltipPosition.top,
                      left: tooltipPosition.left,
                      background: "#212529",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontSize: "11px",
                      zIndex: 2000,
                      maxWidth: "300px",
                      // whiteSpace: "nowrap",
                    }}
                  >
                    {tooltipContent}
                    <div style={{width: 0,height: 0,borderRight: '15px solid transparent',borderBottom: '15px solid transparent',borderTop: '15px solid #212529',position: 'absolute',borderLeft: '15px solid transparent',left: '40%'}}></div>


                  </div>
                )}
              </div>
              {filteredData.length > 0 && (
                <div className="pagination" style={{ marginTop: "20px" }}>
                  <div className="pagination-info">
                    Showing {(currentPage - 1) * PAGE_SIZE + 1} -{" "}
                    {Math.min(currentPage * PAGE_SIZE, filteredData.length)} of{" "}
                    {filteredData.length} items
                  </div>
                  <div className="pagination-control">
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                    >
                      <ChevronLeft size={20} />
                    </button>
                    {[...Array(totalPages)].map((_, i) => (
                      <button
                        key={i}
                        className={currentPage === i + 1 ? "active" : ""}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                    <button
                      onClick={() =>
                        setCurrentPage((p) => Math.min(totalPages, p + 1))
                      }
                      disabled={currentPage === totalPages}
                    >
                      <ChevronRight size={20} />
                    </button>
                  </div>
                </div>
              )}

            { filteredData.length === 0 && searchTerm && (
              <div className="empty-state">
                <div className="empty-state-content">
                  <div class="icon">
                    <img
                      src={emptySearchImg}
                      alt="avatar"
                      className="avatar"
                      style={{
                        width: 120,
                        height: 120,
                        verticalAlign: "middle",
                      }}
                    />
                  </div>
                  <h1 class="no-item-title mt-2">
                    No Orders Found
                  </h1>
                  <p class="no-item-text">
                    No results match what you're looking for
                  </p>
                </div>
              </div>
            ) }
            { pageData.length === 0 && !searchTerm && (
              <div className="empty-state">
                <div className="empty-state-content">
                  <div class="icon">
                    <img
                      src={noBrandImage}
                      alt="avatar"
                      className="avatar"
                      style={{
                        width: 120,
                        height: 120,
                        verticalAlign: "middle",
                      }}
                    />
                  </div>
                  <h1 class="no-item-title mt-2">
                    No Orders Found
                  </h1>
                  <p class="no-item-text">
                    Nothing here yet.
                  </p>
                </div>
              </div>
            ) }
            </div>
          </div>
        )}
      </div>

      {/* Add necessary CSS */}
      <style jsx>{`
        .status-badge {
          display: inline-block;
          padding: 2px 8px;
          font-size: 11px;
          font-weight: 600;
          width: fit-content;
          border-radius: 99px;
        }
        .status-badge.to-ship {
          color: #6C757D;
          border: 1px solid #6C757D;
          background: #F8F9FA;
        }
        .status-badge.shipping {
          color: #CC9A06;
          border: 1px solid #CC9A06;
          background: #FFF3CD;
        }
        .status-badge.completed {
          border: 1px solid #146C43;
          background: #D1E7DD;
          color: #146C43;
        }
        .status-badge.cancelled {
          border: 1px solid #B02A37;
          background: #F8D7DA;
          color: #B02A37;
        }
        .table-wrapper {
          position: relative;
          background: white;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .table-wrapper::-webkit-scrollbar {
          display: none;
        }
        .entities-table {
          width: 100%;
          border-collapse: collapse;
        }
        .entities-table th {
          font-size: 12px;
          font-weight: 700;
          color: #212529;
          border-bottom: 1px solid #E9ECEF;
          white-space: nowrap;
        }
        .entities-table td {
          padding: 10px;
          font-size: 12px;
          color: #212529;
          border-bottom: 1px solid #E9ECEF;
        }
        .entities-table tr:last-child td {
          border-bottom: none;
        }
        .entities-table tr.striped {
          background-color: #F8F9FA;
        }
        .entities-table tr.row-selected {
          background-color: #E7F5FF;
        }
        /* Sticky first & last columns */
        .entities-table td.sticky-first-col {
          position: sticky;
          left: 0;
          z-index: 2;
          background-color: #ffffff;
          box-shadow: 4px 0 6px -4px rgba(0,0,0,0.18);
        }
        .entities-table td.sticky-last-col {
          position: sticky;
          right: 0;
          z-index: 2;
          background-color: #ffffff;
          box-shadow: -4px 0 6px -4px rgba(0,0,0,0.18);
        }
        .entities-table tr.striped td.sticky-first-col,
        .entities-table tr.striped td.sticky-last-col {
          background-color: #F8F9FA;
        }
        .entities-table tr.row-selected td.sticky-first-col,
        .entities-table tr.row-selected td.sticky-last-col {
          background-color: #E7F5FF;
        }
        .search-box {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border: 1px solid #DEE2E6;
          border-radius: 8px;
          background: white;
        }
        .search-box input {
          border: none;
          outline: none;
          width: 100%;
          font-size: 14px;
          background: transparent;
        }
        .action-btn {
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          border-radius: 4px;
        }
        .action-btn:hover {
        background-color: #F1F3F5;
        }
        .action-dropdown-menu{
         background: white;
         padding: 4px 8px;
        }
        .dropdown-item {
          background: white;
        }
        .dropdown-item:hover {
          background: white !important;
        }
        .dropdown-item button {
          width: 100%;
          border: none;
          background: white;
          text-align: left;
          cursor: pointer;
          font-size: 12px;
          color: #212529;
          border-radius: 4px;
        }
        .dropdown-item button:hover {
          background: white !important;
        }
        .pagination {
          display: flex;
          justify-content: end;
          align-items: center;
          padding: 16px 0;
        }
        .pagination-info {
          font-size: 12px;
          color: #6C757D;
        }
        .pagination-control {
          display: flex;
          gap: 4px;
        }
        .pagination-control button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border: 1px solid #DEE2E6;
          border-radius: 4px;
          background: white;
          cursor: pointer;
          color: #212529;
        }
        .pagination-control button.active {
          background: #FFEB00;
          border-color: #FFEB00;
          font-weight: 600;
        }
        .pagination-control button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .sorticon{
          line-height:1.3!important;
        }
      `}</style>
    </div>
  );
}
